import React, { useState } from "react";
import Button from "../../Component/Button/Button";
import Style from "./UpdateAddress.module.css";
import { useForm } from "react-hook-form";
import '../../Component/Map/Map.css'
import { useHistory } from "react-router-dom";
import UpdateMap from "../../Component/UpdateMap/UpdateMap";
import { AddressDetailPostApi} from "../../Api/BarestServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Cities = [
  {
    id: 4851,
    name: "بهشهر", 
  },
  {
    id: 4841,
    name: "نکا",
  },
  {
    id: 4861, 
    name: "گلوگاه",
  },
];
const UpdateAddress = (props) => {
  const history = useHistory();
  const [center, setCenter] = useState([53.54347, 36.69056]); 
  const [, setCity] = useState("4851");
  const [text, setText] = useState("");
  const [polygon, setPolygon] = useState({
    type: "Polygon",
    coordinates: [
      [
        [53.4949, 36.689295],
        [53.52434, 36.705901],
        [53.567101, 36.708051],
        [53.602236, 36.692963],
        [53.549487, 36.675879],
      ],
    ],
  });
  
  const clickCities = (item) => {
    setCity(item);
    switch (item) {
      case "4851":
        setCenter([53.54347, 36.69056]);
        setPolygon({
          type: "Polygon",
          coordinates: [
            [
              [53.4949, 36.689295],
              [53.52434, 36.705901],
              [53.567101, 36.708051],
              [53.602236, 36.692963],
              [53.549487, 36.675879],
            ],
          ],
        });
        break;
      case "4841":
        setCenter([53.29457, 36.64757]);
        setPolygon({
          type: "Polygon",
          coordinates: [
            [
              [53.300077, 36.667256],
              [53.286937, 36.654596],
              [53.263388, 36.629691],
              [53.292008, 36.636236],
              [53.314657, 36.636099],
            ],
          ],
        });
        break;
      case "4861":
        setCenter([53.80904, 36.72767]);
        setPolygon({
          type: "Polygon",
          coordinates: [
            [
              [53.807987, 36.716448],
              [53.819654, 36.726218],
              [53.825345, 36.736301],
              [53.797383, 36.732714],
              [53.800467, 36.726381],
            ],
          ],
        });
        break;

      default:
        setCenter([53.54347, 36.69056]);
    }
  }

  const {
    handleSubmit,
  } = useForm();
////////send address detail to update address page////////
  const onSubmit = () => {
    let info={
      id:props.location.state
    }
    AddressDetailPostApi(info,res=>{
      history.push({ pathname: "/updateaddressinfo", state: res.address});
    })
  };

  ///////////////get text input from child ///////////////

  
  return (
    <div className={Style.DivHolder}>
      <div onClick={() => history.goBack()} className={Style.backStyle}>
        <FontAwesomeIcon  icon={faArrowRight} className={Style.backIcon}/>
      </div>
      <UpdateMap text={text} center={center} polygon={polygon} />
      <form className={Style.Search} onSubmit={handleSubmit(onSubmit)}>
        <div className={Style.InputHolder}>
          <select
            name="city"
            className={Style.CityHolder}
            onChange={(e) => clickCities(e.target.value)}
          >
            {Cities.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>
          <input 
          value={text} 
          onChange={(e)=>{setText(e.target.value)}} 
          className={Style.text}
          placeholder={"جست و جو..."}
          />
        </div>
        <Button
          Value={"تایید"}
          ClassBtn={"confrimBtn"}
          // disabledProps={disable}
        />
      </form>
    </div>
  );
};
export default UpdateAddress;
